import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalComponent } from '../../../../config/core.modal-helpers';
import { AdminService } from '../../../../services/core.admin.service';
import { UiService } from '../../../../services/core.ui.service';

import * as _ from 'lodash-es';

@Component({
    selector: 'trove-move-modal',
    template: require('./admin.trove-move.modal.component.html')
})
export class TroveMoveModalComponent extends ModalComponent implements OnInit {

    @Input() categories: any = null;
    @Input() category: any = null;

    @Output() onClose = new EventEmitter<boolean>();

    protected newParent: any = null;
    protected childPath: string = '';
    protected categoryFilter: string = '';
    private flatCategoryList = [];
    protected categoriesDisplay: any = null;
    private excludedIds: Set<number> = new Set();

    protected treeOptions: any = {
        displayField: 'title',
        idField: 'id',
        childrenField: 'nodes',
        getChildren: (node) => Promise.resolve(node.nodes)
    };

    constructor(
        private adminService: AdminService,
        private uiService: UiService,
    ) { super(); }

    ngOnInit() {
        this.treeOptions.onSelectItem = (item) => {
            this.newParent = item;
        };
        this.childPath = _.map(this.category.categoryPath, 'title').slice(0, -1).join(' / ');
        // Get IDs of the category being moved and its descendants
        this.excludedIds = this.getDescendantIds(this.category);
        // Filters out the category and its descendants
        this.flatCategoryList = this.flattenTree(this.categories).filter(
            cat => !this.excludedIds.has(cat.id)
        );
        this.applyFilter();
    }

    /**
     * Gets the IDs of a category and its descendants
     * These categories are not valid move destinations
     */
    getDescendantIds(category: any): Set<number> {
        const ids = new Set<number>();
        
        const collectIds = (cat: any) => {
            ids.add(cat.id);
            if (cat.nodes && cat.nodes.length > 0) {
                for (let child of cat.nodes) {
                    collectIds(child);
                }
            }
        };
        
        collectIds(category);
        return ids;
    }

    categoryPathString(category: any) {
        return _.map(category.categoryPath, 'title').join(' / ');
    }
    getCategoryPathString = _.memoize(this.categoryPathString, (category: any) => category.id);

    applyFilter(newValue = '') {
        const filter = newValue.trim().toLowerCase();
        if (filter.length) {
            this.categoriesDisplay = this.flatCategoryList.filter(it => {
                return it.title.toLowerCase().indexOf(filter) > -1;
            });
        } else {
            // Filters the tree to exclude the category being moved and its descendants
            this.categoriesDisplay = this.filterTree(this.categories);
        }
    }
    doFilter = _.debounce(this.applyFilter, 250);

    /**
     * Creates a filtered copy of the tree excluding the category being moved and its descendants
     */
    filterTree(categories: any[]): any[] {
        if (!categories) return [];
        
        return categories
            .filter(cat => !this.excludedIds.has(cat.id))
            .map(cat => {
                if (cat.nodes && cat.nodes.length > 0) {
                    return {
                        ...cat,
                        nodes: this.filterTree(cat.nodes)
                    };
                }
                return cat;
            });
    }

    flattenTree(categories) {
        let result = [];
    
        function traverse(category: any) {
            result.push(category);
            if (category.nodes && category.nodes.length > 0) {
                for (let child of category.nodes) {
                    traverse(child);
                }
            }
        }

        for (let node of categories) {
            traverse(node);
        }
        return result;
    }

    doClose() {
        this.close.emit(true);
    }

    doCancel() {
        this.close.emit(false);
    }

    submit() {
        var submitting = {
            id: this.category.id,
            parentCategoryId: this.newParent.id
        }
        this.adminService.postTrove(submitting.id, submitting)
            .then(() => {
                this.doClose();
                this.uiService.message.showSuccess(`Moved '${this.category.title}' to '${this.newParent.title}'`);
            }, () => {
                this.uiService.message.showError('Failed to move category ' + this.category.title);
            }
        );
    }
}